import { APIResponse, returnAxios } from 'app/shared/util/class-utils';
import axios from 'axios';

export interface ICorporateApi {
  getSelectedOffer(offerNumber: string): Promise<APIResponse<any>>;
  getDocumentContent(offerNumber: string, documentUuid: string): Promise<APIResponse<any>>;
  getInsuredGoods(): Promise<APIResponse<any>>;
}

export class CorporateApi implements ICorporateApi {
  async getSelectedOffer(offerNumber: string): Promise<APIResponse<any>> {
    return returnAxios(
      axios.get('journey/offers/' + offerNumber, {
        headers: {
          'Accept-Language': 'fr-FR'
        }
      })
    );
  }

  async getOfferDocuments(offerCode: string): Promise<APIResponse<any>> {
    return returnAxios(
      axios({
        url: '/journey/offers/' + offerCode + '/documents',
        method: 'GET'
      })
    );
  }


  async getSignCertifiedDocuments(subscriptionNumber: string, token: string): Promise<APIResponse<any>> {
    return returnAxios(
      axios({
        url: `/journey/subscriptions/${subscriptionNumber}/documents/sign-certified`,
        method: 'GET',
        headers: {
          'X-Subscription-Token': token
        }
      })
    );
  }

  async getDocumentContent(documentType: string): Promise<APIResponse<any>> {
    return returnAxios(
      axios({
        url: 'journey/offers/documents/' + documentType,
        method: 'GET',
        responseType: 'blob'
      })
    );
  }

  async getSignedDocumentContent(
    subscriptionNumber: string,
    documentType: string,
    documentToken: string
  ): Promise<APIResponse<Blob>> {
    return returnAxios(
      axios.get(`journey/subscriptions/documents/${documentType}/content`, {
        params: { subscriptionNumber },
        headers: { 'X-Document-Token': documentToken },
        responseType: 'blob'
      })
    );
  }


  async getProcessedDocuments(subscriptionNumber: string, token: string): Promise<APIResponse<any>> {
    return axios.get(`journey/subscriptions/${subscriptionNumber}/documents/processed`, {
      headers: {
        'X-Subscription-Token': token
      }
    });
  }

  async getInsuredGoods(): Promise<APIResponse<any>> {
    return returnAxios(
      axios.get('api/insuredgoods', {
        headers: {
          'Accept-Language': 'fr-FR'
        }
      })
    );
  }
}
